import { FieldErrors } from 'react-hook-form';

import { getAllInvoiceDiscrepancies } from './utils';
import { NavigationService } from '../schemableFormNavigation/schemableFormNavigation';
import { sortArrayBasedOnConfig } from '../schemableFormNavigation/sortItems';
import { scrollToDiscrepancy } from './navigationHelpers';
import { ConfigItem, InvoiceDiscrepancy } from './types';

export class InvoiceDiscrepanciesService extends NavigationService<InvoiceDiscrepancy> {
  constructor() {
    super();
  }

  focusOnCurrentItem = async (): Promise<void> => {
    const currentError = this.getCurrentItem();
    if (currentError) {
      return scrollToDiscrepancy(currentError, this.scrollToVirtualizedRow, this.containerRef);
    }
    return scrollToDiscrepancy(this.store.getState().items[0], this.scrollToVirtualizedRow, this.containerRef);
  };

  processDocumentDiscrepancies = <TSection extends ConfigItem>(
    formErrors: FieldErrors,
    data: Record<string, unknown>,
    uiConfig?: Array<TSection>,
  ): void => {
    const discrepancies = getAllInvoiceDiscrepancies(formErrors, data);
    if (!discrepancies || !uiConfig) {
      return;
    }

    const organizedErrors = sortArrayBasedOnConfig(Array.from(Object.values(discrepancies)), uiConfig);
    this.setItems(organizedErrors);
  };
}
